module.exports = __webpack_public_path__ + "static/media/international.017db7ad.svg";